import {
  BackgroundColorInterface,
  BackgroundImageInterface,
  BackgroundStylesInterface,
} from 'common/types/background-interfaces'
import {
  backgroundColorCss,
  backgroundCss,
  borderCss,
  mobileBackgroundCss,
  mobileBorderCss,
} from 'common/utils/styleUtilsNew'
import { BorderEntityInterface } from 'src/shared/schemas/border.schema'
import { css, styled } from 'styled-components'

export interface WebsiteFooterBackgroundUiProps
  extends BorderEntityInterface,
    BackgroundColorInterface,
    BackgroundImageInterface {
  background?: BackgroundStylesInterface
  mobileBackground?: string
  backgroundImage?: string | null
  mobileBackgroundImage?: string | null
}

export const WebsiteFooterBackgroundUi = styled.footer<WebsiteFooterBackgroundUiProps>`

  ${backgroundCss}
  ${backgroundColorCss}
  ${p =>
    p.backgroundImage &&
    css`
      background-image: ${p.backgroundImage};
    `};
  ${borderCss}

  ${p => p.theme.phone} {
    
    ${mobileBackgroundCss}
    ${mobileBorderCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      background-image: ${p.mobileBackgroundImage ?? 'none'};
      ${mobileBackgroundCss} 
      ${mobileBorderCss}
    `}

`
